import { render, staticRenderFns } from "./cca_management.vue?vue&type=template&id=3c961faa&scoped=true&"
import script from "./cca_management.vue?vue&type=script&lang=js&"
export * from "./cca_management.vue?vue&type=script&lang=js&"
import style0 from "./cca_management.vue?vue&type=style&index=0&id=3c961faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c961faa",
  null
  
)

export default component.exports